import { Footer, GradientBg, Header } from "../components"
import type { NextPage } from "next"

const WarrantyAndFraudStatements: NextPage = () => {
  return (
    <>
      <GradientBg />
      <Header />
      <div className="text-base relative mx-auto py-16 sm:py-32 px-4 prose prose-lg prose-a:text-primary hover:prose-a:text-primaryHover">
        <div className="text-center">
          <h1 className="text-2xl font-bold">Warranty and Fraud Statements</h1>
        </div>
        <div className="mt-16">
          <h2 className="text-xl font-bold">
            Warranty: Prior Knowledge of Facts, Circumstances, or Situations
          </h2>

          <p>
            You as a potential insured are directly declaring that to the best
            of your knowledge, after reasonable inquiry, the statements herein
            are true. It is agreed that this Application shall be the basis of
            the contract should a Policy be issued, and this Application will be
            attached to and become a part of such Policy, if issued. Insurer
            hereby is authorized to make any investigation and inquiry in
            connection with this Application as they may deem necessary and can
            audit and adjust premium rates at any point throughout the policy
            term. The Company will have relied upon such Applicant, attachments,
            and such other information submitted therewith in issuing such
            policy. The undersigned further certifies that he/she has read the
            applicable fraud notices referenced below in this Application and
            that none of the information provided herein has been provided in
            violation of any applicable insurance fraud laws or regulations.
          </p>

          <h2 className="text-xl font-bold mt-8">Fraud Statements</h2>

          <h3 className="text-lg font-bold mt-6">General Statements</h3>
          <p>
            Any person who knowingly and with intent to defraud any insurance
            company or another person files an application for insurance or
            statement of claim containing any materially false information, or
            conceals for the purpose of misleading, information concerning any
            fact material thereto, commits a fraudulent insurance act, which is
            a crime and subjects the person to criminal and civil penalties.
            (Applicable in all states except those specifically identified
            below).
          </p>

          <h3 className="text-lg font-bold mt-6">
            Applicable in Alabama, Arkansas, Louisiana, Maryland, New Mexico,
            Rhode Island and West Virginia
          </h3>
          <p>
            Any person who knowingly (or willfully)* presents a false or
            fraudulent claim for payment of a loss or benefit or knowingly
            presents false information in an application for insurance is guilty
            of a crime and may be subject to (civil)** fines and (criminal
            penalties)** confinement in prison. *Applies in MD only. ** Applies
            in NM only.
          </p>

          <h3 className="text-lg font-bold mt-6">Applicable in Colorado</h3>
          <p>
            It is unlawful to knowingly provide false, incomplete, or misleading
            facts or information to an insurance company for the purpose of
            defrauding or attempting to defraud the company. Penalties may
            include imprisonment, fines, denial of insurance and civil damages.
            Any insurance company or agent of an insurance company who knowingly
            provides false, incomplete, or misleading facts or information to a
            policyholder or claimant for the purpose of defrauding or attempting
            to defraud the policyholder or claimant with regard to a settlement
            or award payable from insurance proceeds shall be reported to the
            Colorado Division of Insurance within the Department of Regulatory
            Agencies.
          </p>

          <h3 className="text-lg font-bold mt-6">
            Applicable in the District of Columbia
          </h3>
          <p>
            Warning: it is a crime to provide false or misleading information to
            an insurer for the purpose of defrauding the insurer or any other
            person. Penalties include imprisonment and/or fines. In addition, an
            insurer may deny insurance benefits if false information materially
            related to a claim was provided by the applicant.
          </p>

          <h3 className="text-lg font-bold mt-6">Applicable in Florida</h3>
          <p>
            Any person who knowingly, and with intent to injure, defraud, or
            deceive any insurer files a statement of claim or an application
            containing any false, incomplete or misleading information is guilty
            of a felony of the third degree.
          </p>

          <h3 className="text-lg font-bold mt-6">Applicable in Hawaii</h3>
          <p>
            For you protection, Hawaii law requires you to be informed that
            presenting a fraudulent claim for payment of a loss or benefit is a
            crime punishable by fines or imprisonment, or both.
          </p>

          <h3 className="text-lg font-bold mt-6">Applicable in Kansas</h3>
          <p>
            Any person who, knowingly and with intent to defraud, presents,
            causes to be presented or prepares with knowledge or belief that it
            will be presented to or by an insurer, purported insurer, broker or
            any agent thereof, any written statement as part of, or in support
            of, an application for the issuance of, or the rating of an
            insurance policy for personal or commercial insurance, or a claim
            for payment or other benefit pursuant to an insurance policy for
            commercial or personal insurance which such person knows to contain
            materially false information concerning any fact material thereto;
            or conceals, for the purpose of misleading, information concerning
            any fact material thereto commits a fraudulent insurance act.
          </p>

          <h3 className="text-lg font-bold mt-6">
            Applicable in Kentucky, New York and Pennsylvania
          </h3>
          <p>
            Any person who knowingly and with intent to defraud any insurance
            company or other person files an application for insurance or
            statement of claim containing any materially false information or
            conceals for the purpose of misleading, information concerning any
            fact material thereto commits a fraudulent insurance act, which is a
            crime (and subjects such person to criminal and civil penalties)*
            (not to exceed five thousand dollars and the stated value of the
            claim for each such violation)**.*Applies in NY and PA only.
            **Applies in NY Only.
          </p>

          <h3 className="text-lg font-bold mt-6">
            Applicable in Massachusetts and Nebraska
          </h3>
          <p>
            Any person who knowingly and with intent to defraud any insurance
            company or another person files an application for insurance or
            statement of claim containing any materially false information, or
            conceals for the purpose of misleading information concerning any
            fact material thereto, may be committing a fraudulent insurance act,
            which may be a crime and may subject the person to criminal and
            civil penalties.
          </p>

          <h3 className="text-lg font-bold mt-6">
            Applicable in Maine, Tennessee, Virginia and Washington
          </h3>
          <p>
            It is a crime to knowingly provide false, incomplete, or misleading
            information to an insurance company for the purpose of defrauding
            the company. Penalties (may)* include imprisonment, fines, and
            denial of insurance benefits. * Applies in ME Only.
          </p>

          <h3 className="text-lg font-bold mt-6">Applicable in Minnesota</h3>
          <p>
            A person who files a claim with intent to defraud or helps commit a
            fraud against an insurer is guilty of a crime.
          </p>

          <h3 className="text-lg font-bold mt-6">
            Applicable in New Hampshire
          </h3>
          <p>
            Any person who knowingly presents a false or fraudulent claim for
            payment of a loss or benefit or knowingly presents false information
            in an application for insurance is guilty of a crime and may be
            subject to fines and confinement in prison.
          </p>

          <h3 className="text-lg font-bold mt-6">Applicable in New Jersey</h3>
          <p>
            Any person who includes any false or misleading information on an
            application for an insurance policy is subject to criminal and civil
            penalties.
          </p>

          <h3 className="text-lg font-bold mt-6">Applicable in Ohio</h3>
          <p>
            Any person who, with intent to defraud or knowing that he/she is
            facilitating a fraud against an insurer, submits an application or
            files a claim containing a false or deceptive statement is guilty of
            insurance fraud.
          </p>

          <h3 className="text-lg font-bold mt-6">Applicable in Oklahoma</h3>
          <p>
            Warning: Any person who knowingly, and with intent to injure,
            defraud, or deceive any insurer, makes any claim for the proceeds of
            an insurance policy containing any false, incomplete or misleading
            information is guilty of a felony.
          </p>

          <h3 className="text-lg font-bold mt-6">Applicable in Oregon</h3>
          <p>
            Any person who knowingly and with intent to defraud or solicit
            another to defraud the insurer by submitting an application
            containing a false statement as to any material fact may be
            violating state law.
          </p>

          <h3 className="text-lg font-bold mt-6">Applicable in Vermont</h3>
          <p>
            Any person who knowingly presents a false statement in an
            application for insurance may be guilty of a criminal offense and
            may be subject to penalties under state law.
          </p>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default WarrantyAndFraudStatements
